<template>
    <div class="row">
        <div :class="[classes]">
            <h5 v-if="title">{{ title ?? "" }}</h5>
            <p v-if="description">
                <small>
                    {{ description ?? "" }}
                </small>
            </p>
        </div>
        <div class="col-md">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: String,
        description: String,
        isFieldsetRow: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        classes() {
            return {
                "col-md-4": !this.isFieldsetRow,
                "col-md-12": this.isFieldsetRow,
            }
        },
    }
}
</script>